import React, { useEffect, useState } from 'react';

/* Shared cinematic hero slideshow: crossfading backgrounds with varied tones
   (warm kitchen, green terrace, city evening, colorful market). */

export const KX_HERO_SLIDES = [
  '/heros/orange-kitchen.jpg',
  '/heros/green-terrace.jpg',
  '/heros/city-evening.jpg',
  '/heros/market-color.jpg',
];

export const HeroSlideshow = ({ slides = KX_HERO_SLIDES, interval = 5200, overlay = '', testId = 'hero-slideshow' }) => {
  const [slide, setSlide] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSlide((s) => (s + 1) % slides.length), interval);
    return () => clearInterval(t);
  }, [slides.length, interval]);
  return (
    <div className="absolute inset-0" data-testid={testId} aria-hidden="true">
      {slides.map((src, i) => (
        <img key={src} src={src} alt="" loading={i === 0 ? 'eager' : 'lazy'}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1600ms] ease-in-out ${i === slide ? 'opacity-100' : 'opacity-0'}`} />
      ))}
      {overlay && <div className={`absolute inset-0 ${overlay}`} />}
      <div className="absolute bottom-4 right-5 flex gap-1.5">
        {slides.map((_, i) => (
          <span key={i} className={`w-1.5 h-1.5 rounded-full transition-colors duration-500 ${i === slide ? 'bg-[#F77F11]' : 'bg-white/40'}`} />
        ))}
      </div>
    </div>
  );
};
